const e = () => typeof window == "undefined";
export { e as isSSR };